import React, { useContext, useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Input, Button, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import { Filter, AlertTriangle, AlertCircle, TrendingUp, AlertOctagon, MapPin, Power } from 'react-feather';
import HeatmapForArea from './New componens/Grapgh/HeatmapForAreaV2';
import CommonFIlterButton from '../../../Common/commonFilterButton/CommonFIlterButton';
import { Shifts } from '../../../../Data/staticData/data';
import { formatMonth, formatWeek } from '../../../../utils/formatDate';
import { getCurrentWeekWithYear } from '../../../../utils/currentWeekWithYear';
import './LiveAnalyticsNewDesgin.css';
import './liveanalytics.css';
// import UniIcon from "../../assets/images/logo/uni-logo.jpeg"
import AreaService from '../../../../api/areaService';
import LiveAlertsFilters from '../../../Dashboards/AreaDashbaord/reports/Components/DateFilters/LiveAlertsFilters';
import { errorToast, successToast } from '../../../../_helper/helper';
import { IoCheckmarkOutline } from 'react-icons/io5';
import { RxReset } from 'react-icons/rx';
import { RiMenu5Line } from 'react-icons/ri';
import DynamicModulesContext from "../../../../_helper/formData/DynamicModules/DynamicModulesContext";
import { apiBaseUrl } from '../../../../api/api';
import { dateChoose } from '../../../Screens/GlobalUser/AIModelReports/Components/data/staticData';



const LiveAnalyticsNewDesgin = ({ heatmapData: externalHeatmapData, filters: externalFilters }) => {
  const [loading, setloading] = useState(true)
  const [filters, setFilters] = useState({
    week: getCurrentWeekWithYear(),
    month: '',
    date: '',
    shift: '',
    area: '',
    subarea: '',
    shiftId: ''
  });
  const [showFilters, setShowFilters] = useState(false);
  const [focusClass] = useState('');
  const filterCardRef = useRef(null);
  const filterButton = useRef(null);
  const [AllLiveAlerts, setAllLiveAlerts] = useState([]);
  const [online, setOnline] = useState(true);
  const [heatmapLiveData, setheatmapLiveData] = useState()

  const [callapi, setcallapi] = useState(false)
  const [selectedOption, setSelectedOption] = useState('Week');
  const [dateShow, setDateShow] = useState(false);
  const [monthShow, setMonthShow] = useState(false);
  const [weeklyShow, setWeeklyShow] = useState(true);

  const style = {
    minWidth: "132px",
    width: "144px",
    maxWidth: "150px",
    height: "38px",
    fontSize: 13,
  };

  const [areas, setAreas] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [subareas, setSubAreas] = useState({});
  const [showButtons, setShowButtons] = useState(false);
  const { AllActiveModules, setAllActiveModules } = useContext(DynamicModulesContext);




  const factoryID = JSON.parse(localStorage.getItem('userData'))?.factory?.id

  function applyfilters() {
    localStorage.setItem('dashfilters', JSON.stringify(filters))
    setloading(true)
    setcallapi(!callapi)

  }

  function Reset() {
    setloading(true)
    setSelectedOption('Week')
    setDateShow(false)
    setMonthShow(false)
    setWeeklyShow(true)
    setFilters({
      week: getCurrentWeekWithYear(),
      month: '',
      date: '',
      shift: '',
      area: '',
      subarea: '',
      shiftId: ''
    })
    const update = {
      week: getCurrentWeekWithYear(),
      month: '',
      date: '',
      shift: '',
      area: '',
      subarea: '',
      shiftId: ''
    }
    localStorage.setItem('dashfilters', JSON.stringify(update))
    setcallapi(!callapi)
  }




  function socketConnection() {

    const fils = JSON.parse(localStorage.getItem('dashfilters'))
    const socket = new WebSocket(`wss://${apiBaseUrl.split('//')[1]}ws/live_alerts_broadcast`)

    socket.onopen = () => {
      console.log('socket connected')
    }

    socket.onmessage = async (event) => {
      console.log('socket data', event?.data)
      const call = true;
      if (fils?.area == '') {

        getAlerts(call)
        getHeatmapData()
      }
    }
    // socket.onclose = () => {
    //     console.log('WebSocket connection closed.');
    //   };

    socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };




  }


  useEffect(() => {



    socketConnection()
  }, [])





  //  useEffect(() => {



  //   async function triggerApis() {
  //     try {

  //       await Promise.all([
  //         getAlerts(),
  //         getHeatmapData(),
  //       ])

  //     } catch (error) {
  //       return errorToast('Error Fetching Data')
  //     }
  //   }


  //    if (filters?.area=='') {
  //     triggerApis()
  //    }


  //  }, [socketAlert])



  //   useEffect(() => {

  //     // const socket = new WebSocket(`wss://stage-beunilever.disruptlabs.tech/ws/live_alerts_broadcast`)


  //     //    socket.onopen = () => {
  //     //   console.log('WebSocket connection established.');
  //     // };


  //     // socket.onmessage = (event) => {
  //     //   const data = event.data;
  //     //   console.log('Message received:', data);
  //     //   setMessages((prev) => [...prev, data]);
  //     // };

  //     // socket.onclose = () => {
  //     //   console.log('WebSocket connection closed.');
  //     // };

  //     // socket.onerror = (error) => {
  //     //   console.error('WebSocket error:', error);
  //     // };

  //     // Cleanup on unmount
  //     // return () => {
  //     //   socket.close();
  //     // };


  //     const ws = new WebSocket("wss://stage-beunilever.disruptlabs.tech/ws/live_alerts_broadcast");

  // ws.onopen = () => console.log("✅ connected");
  // ws.onmessage = (event) => console.log("📩 got message:", event.data);
  // ws.onclose = () => console.log("❌ closed");
  // ws.onerror = (err) => console.error("⚠️ error:", err);

  //   }, [])

const [supervisors, setsupervisors] = useState([])
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [selectedSupervisor, setSelectedSupervisor] = useState(null);
  const [statusUpdating, setStatusUpdating] = useState(false);

  const openStatusModal = (supervisor) => {
    setSelectedSupervisor(supervisor);
    setStatusModalOpen(true);
  };

  const closeStatusModal = () => {
    if (statusUpdating) return;
    setStatusModalOpen(false);
    setSelectedSupervisor(null);
  };

  const handleConfirmStatusChange = async () => {
    if (!selectedSupervisor) return;
    try {
      setStatusUpdating(true);
      await AreaService.updateSupervisorStatus({ supervisor_id: selectedSupervisor?.user_id });
      setsupervisors((prev) =>
        prev?.map((sup) =>
          sup?.user_id === selectedSupervisor?.user_id
            ? { ...sup, shift_status: !sup?.shift_status }
            : sup
        )
      );
      successToast(
        `Shift status ${selectedSupervisor?.shift_status ? 'deactivated' : 'activated'} successfully`
      );
      setStatusModalOpen(false);
      setSelectedSupervisor(null);
    } catch (error) {
      console.error('Error while updating supervisor shift status:', error);
      errorToast('Failed to update shift status');
    } finally {
      setStatusUpdating(false);
    }
  };

  useEffect(() => {
    // setLoader(true)
    const updateSubAreas = (mappedAreas) => {
      const subs = mappedAreas.reduce((acc, a) => {
        acc[a.area] = a.sub_area; // Set `area_name` as the key and `sub_area` as the value
        return acc;
      }, {});
      // Update the state
      setSubAreas(subs);
    };
    async function fetchArea() {
      try {
        const payload = {
          user_id: JSON.parse(localStorage.getItem("userData"))?.id,
          factory_id: factoryID,
        };
        const res = await AreaService.GetAllAreas(factoryID);
        if (res) {
          // setLoader(false)
        }
        setAreas(res?.data?.data?.areas);
        const mappedAreas =
          res?.data?.data?.areas &&
          res?.data?.data?.areas.map((area) => ({
            ...area,
            label: `${area.area}, ${area.areaOwner}`,
            disabled: !area.active,
          }));
        updateSubAreas(mappedAreas);
      } catch (error) {
        console.log(error);
        errorToast("Error while fetching areas");
      }
    }

    async function fetchShifts() {
      try {
        const res = await AreaService.getAllShifts();
        const options = (res?.data?.data || res?.data || []).map(s => ({ label: s?.shift_name || s?.name || s?.label, value: s?.id || s?.shift_id }));
        console.log(options)
        setShifts(options);
      } catch (err) {
        console.log(err);
      }
    }

    let fils = {};
    try { fils = JSON.parse(localStorage.getItem('dashfilters')) || {}; } catch { }
    if (!fils || Object.keys(fils).length === 0) {
      localStorage.setItem('dashfilters', JSON.stringify(filters));
    } else {
      setFilters((prev) => ({ ...prev, ...fils }));
      if (fils.date) {
        setSelectedOption('Daily');
        setDateShow(true);
        setMonthShow(false);
        setWeeklyShow(false);
      } else if (fils.month) {
        setSelectedOption('Month');
        setDateShow(false);
        setMonthShow(true);
        setWeeklyShow(false);
      } else {
        setSelectedOption('Week');
        setDateShow(false);
        setMonthShow(false);
        setWeeklyShow(true);
      }
    }

    const fetchSupervisorAlerts = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userId = userData?.id || 0;
      const factoryId = userData?.factory?.id || 0;

      const fils = JSON.parse(localStorage.getItem('dashfilters'))

      // current week string e.g. "2025-W36"
      const currentWeekStr = getCurrentWeekWithYear();

      // split year and week
      let [year, week] = currentWeekStr.split("-W");
      year = parseInt(year, 10);
      week = parseInt(week, 10);

      let allWeeksData = [];

      
        // Single call for current week only
        const formattedWeek = `${year}-W${String(week).padStart(2, "0")}`;

        let payloadDate = "";
        let payloadWeek = "";
        let payloadMonth = "";

        if (fils?.date) {
          payloadDate = fils.date;
        } else if (fils?.month) {
          payloadMonth = fils.month;
        } else {
          payloadWeek = fils?.week || formattedWeek;
        }

        const payload = {

          factory_id: factoryId,

            date: payloadDate,
            week: payloadWeek,
            month: payloadMonth,
            starting: "",
            ending: "",
            area: fils?.area,
            shift: fils?.shift ? [fils.shift] : [],
            sub_area: fils?.subarea,
            supervisor_validation: fils?.approval === 'Accepted' ? true : null,



        };

        const res = await AreaService.supervisorAlerts(payload);
        console.log('supervisors', res?.data?.data?.supervisorData)
        setsupervisors(res?.data?.data?.supervisorData)

      console.log("Final merged data:", allWeeksData);
      return setAllLiveAlerts(allWeeksData);

    } catch (error) {
      console.error("Error while fetching alerts:", error);
    }
  };

    // --- added: prevent overlapping runs + proper cleanup ---
    let inFlight = false;
    let cancelled = false;
    const call = false

    const run = async () => {
      if (inFlight || cancelled) return; // skip if a batch is already running or effect is cleaning up
      inFlight = true;
      try {
        await Promise.all([
          fetchArea(),
          fetchShifts(),
          fetchSupervisorAlerts(),
          getAlerts(call),
          getHeatmapData(),
        ]);
        if (!cancelled) setloading(false);
      } finally {
        inFlight = false;
      }
    };

    // run immediately once
    run();

    // run every 10 seconds
    // const intervalId = setInterval(run, 20000);

    // // cleanup on unmount / when callapi changes
    // return () => {
    //   cancelled = true;
    //   clearInterval(intervalId);
    // };
  }, [callapi]);



  const mockHeatmapData = {
    sub_area: ['Rafay Waqar', 'Maria Aftab', 'Makhdoom Sheraz', 'Haris Amjad'],
    data: [
      { name: 'No-GO Area', data: [-1, -1, 30, 355] },
      { name: 'Emergency Exit', data: [-1, 0, 0, 0] },
      { name: 'MMHE', data: [0, 0, 0, 0] },
      { name: 'Vest', data: [1, 0, 5, 42] },
      { name: 'Helmet', data: [50, 1, 0, 7] },
    ],
  };
  // const heatmapData = externalHeatmapData || mockHeatmapData;

  // Desired heatmap color scheme and thresholds
  const uiFilters = {
    colors: {
      normal: '#43A047',   // green
      trouble: '#F4B400',  // yellow
      critical: '#E53935', // red
      na: '#F2F3F5'        // light gray
    },
    thresholds: {
      trouble: 1,   // >0 => yellow
      critical: 5   // >=5 => red
    }
  };
  const filtersFromStorage = (() => {
    try { return JSON.parse(localStorage.getItem('dashfilters')) || {}; } catch { return {}; }
  })();
  const effectiveFilters = externalFilters || filtersFromStorage || {};


  // useEffect(() => {
  //   // Simulate data fetch/state wiring like live page; keep inline data for now
  //   const t = setTimeout(() => setHeatmapLoader(false), 300);
  //   return () => clearTimeout(t);
  // }, []);



  const getAlerts = async (times) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData")) || {};
      const userId = userData?.id || 0;
      const factoryId = userData?.factory?.id || 0;

      const fils = JSON.parse(localStorage.getItem('dashfilters'))

      // current week string e.g. "2025-W36"
      const currentWeekStr = getCurrentWeekWithYear();

      // split year and week
      let [year, week] = currentWeekStr.split("-W");
      year = parseInt(year, 10);
      week = parseInt(week, 10);

      let allWeeksData = [];

      if (times) {
        // Single call for current week only
        const formattedWeek = `${year}-W${String(week).padStart(2, "0")}`;

        let payloadDate = "";
        let payloadWeek = "";
        let payloadMonth = "";

        if (fils?.date) {
          payloadDate = fils.date;
        } else if (fils?.month) {
          payloadMonth = fils.month;
        } else {
          payloadWeek = fils?.week || formattedWeek;
        }

        const payload = {
          user_id: userId,
          factory_id: factoryId,
          identifier: fils?.date ? "date" : fils?.month ? "month" : "week",
          role: "factory",
          supervisor_validation: fils?.approval === 'Accepted' ? true : null,
          filters: {
            approval: "Select Approval",
            module: "",
            severity: "",
            shift: fils?.shift ? [fils.shift] : [],
            subarea: fils?.subarea,
            date: payloadDate,
            week: payloadWeek,
            month: payloadMonth,
            starting: "",
            ending: "",
            area: fils?.area,
            acknowledge: ""
          },
          pagination: {
            page_no: 1,
            per_page: 21
          }
        };

        const res = await AreaService.getFilterAlerts(payload);
        if (res?.data?.data) {
          const partialResponse = {
            ...res.data.data,
            week: 0,
            week_label: `Week ${week}`
          };
          allWeeksData = [...allWeeksData, partialResponse];
        }
      } else {
        // Loop over the last 4 periods, matching whichever filter type (daily/week/month) is active
        for (let i = 0; i < 4; i++) {
          let payloadDate = "";
          let payloadWeek = "";
          let payloadMonth = "";
          let periodLabel = "";

          if (fils?.date) {
            const baseDate = new Date(fils.date);
            baseDate.setDate(baseDate.getDate() - i);
            const yyyy = baseDate.getFullYear();
            const mm = String(baseDate.getMonth() + 1).padStart(2, "0");
            const dd = String(baseDate.getDate()).padStart(2, "0");
            payloadDate = `${yyyy}-${mm}-${dd}`;
            periodLabel = payloadDate;
          } else if (fils?.month) {
            let [baseYear, baseMonth] = fils.month.split("-").map(Number);
            let targetMonth = baseMonth - i;
            let targetYear = baseYear;
            while (targetMonth <= 0) {
              targetYear -= 1;
              targetMonth += 12;
            }
            payloadMonth = `${targetYear}-${String(targetMonth).padStart(2, "0")}`;
            periodLabel = payloadMonth;
          } else {
            const [baseYearStr, baseWeekStr] = (fils?.week || currentWeekStr).split("-W");
            const baseYear = parseInt(baseYearStr, 10);
            const baseWeek = parseInt(baseWeekStr, 10);
            let targetWeek = baseWeek - i;
            let targetYear = baseYear;

            if (targetWeek <= 0) {
              targetYear = baseYear - 1;
              targetWeek = 52 + targetWeek;
            }

            payloadWeek = `${targetYear}-W${String(targetWeek).padStart(2, "0")}`;
            periodLabel = `Week ${targetWeek}`;
          }

          console.log("Fetching data for period:", payloadDate || payloadMonth || payloadWeek);

          const payload = {
            user_id: userId,
            factory_id: factoryId,
            identifier: fils?.date ? "date" : fils?.month ? "month" : "week",
            role: "factory",
            supervisor_validation: fils?.approval === 'Accepted' ? true : null,
            filters: {
              approval: "Select Approval",
              module: "",
              severity: "",
              shift: fils?.shift ? [fils.shift] : [],
              date: payloadDate,
              week: payloadWeek,
              month: payloadMonth,
              starting: "",
              ending: "",
              area: fils?.area,
              subarea: fils?.subarea,
              acknowledge: ""
            },
            pagination: {
              page_no: 1,
              per_page: 21
            }
          };

          const res = await AreaService.getFilterAlerts(payload);
          let partialResponse;
          if (res?.data.data) {
            partialResponse = {
              ...res?.data.data,
              week: i,
              week_label: periodLabel
            }
            allWeeksData = [...allWeeksData, partialResponse];
          }
        }
      }

      console.log("Final merged data:", allWeeksData);
      return setAllLiveAlerts(allWeeksData);

    } catch (error) {
      console.error("Error while fetching alerts:", error);
    }
  };


  const getHeatmapData = async () => {
    const userData = JSON.parse(localStorage.getItem("userData")) || {};
    const userId = userData?.id || 0;
    const factoryId = userData?.factory?.id || 0;

    const fils = JSON.parse(localStorage.getItem('dashfilters'))

    let payloadDaily = "";
    let payloadWeekly = "";
    let payloadMonth = "";

    if (fils?.date) {
      payloadDaily = fils.date;
    } else if (fils?.month) {
      payloadMonth = fils.month;
    } else {
      payloadWeekly = fils?.week || getCurrentWeekWithYear();
    }

    const payload = {
      "weekly": payloadWeekly,
      "month": payloadMonth,
      "daily": payloadDaily,
      "start_date": "",
      "end_date": "",
      area: fils?.area,
      subarea: fils?.subarea,
      "shift": fils?.shift ? fils.shift : "",
      shiftID: fils?.shiftId ? fils.shiftId : "",
      "user_id": userId,
      "factory_id": factoryId,
      supervisor_validation: fils?.approval === 'Accepted' ? true : null
    }
    const res = await AreaService.heatmaprykadmin(payload)
    if (res.data) {
      console.log(res.data.heatmapData, "heatmap data")
      const FactoryModules = AllActiveModules || []
      const filteredData = res?.data?.heatmapData?.data.filter(item => FactoryModules.includes(item.name));
      const HeatMapUpdatedData = {
        ...res?.data?.heatmapData,
        data: filteredData
      }
      console.log(res.data.heatmapData?.supervisors, "supervisors")
      setheatmapLiveData({
        ...HeatMapUpdatedData,
        sub_area: (fils?.area && fils?.subarea && fils?.supervisors) ? res.data.heatmapData?.supervisors : (fils?.area && fils?.subarea) ? res.data.heatmapData?.supervisors : (fils?.area && !fils?.subarea) ? res.data.heatmapData?.subAreas : res.data.heatmapData?.areaOwner,
        supervisors: res.data.heatmapData?.supervisor
      })
      // setheatmapLiveData(res.data)

    }
  }





  useEffect(() => {
    function handleClickOutside(event) {
      if (filterCardRef.current && filterButton.current && !filterCardRef.current.contains(event.target) && !filterButton.current.contains(event.target)) {
        setShowFilters(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showFilters]);


  const handleDateDrop = (e) => {
    const selected = e.target.value;
    setSelectedOption(selected);
    setShowButtons(true);
    if (selected == 'Month') {
      setMonthShow(true);
      setDateShow(false);
      setWeeklyShow(false);
    } else if (selected == 'Daily') {
      setMonthShow(false);
      setDateShow(true);
      setWeeklyShow(false);
    } else if (selected == 'Week') {
      setMonthShow(false);
      setDateShow(false);
      setWeeklyShow(true);
    }

    setFilters((prev) => {
      const update = { ...prev };
      if (selected == 'Month') {
        update.date = '';
        update.week = '';
      } else if (selected == 'Daily') {
        update.week = '';
        update.month = '';
      } else if (selected == 'Week') {
        update.date = '';
        update.month = '';
      }

      localStorage.setItem('dashfilters', JSON.stringify(update));

      return update;
    });
  };

  const handleInputChange = (e, field) => {
    const { value } = e.target;

    setShowButtons(true)
    setFilters((prev) => {
      if (field == 'area') {
        prev.subarea = ''
      }
      const update = { ...prev };
      if (field == 'shift') {
        const opt = shifts.find(s => (s.label == value || s.value == value));
        console.log(opt, "selected shift")
        update.shift = opt?.label || '';
        update.shiftId = opt?.value || '';
      } else if (field == 'week') {
        update.week = value;
        update.date = '';
        update.month = '';
      } else if (field == 'month') {
        update.month = value;
        update.date = '';
        update.week = '';
      } else if (field == 'date') {
        update.date = value;
        update.week = '';
        update.month = '';
      } else {
        update[field] = value;
      }

      localStorage.setItem('dashfilters', JSON.stringify(update));


      return update;
    });
  };

  const periodTypeLabel = filters?.date ? 'Daily' : filters?.month ? 'Monthly' : 'Weekly';
  const currentPeriodLabel = filters?.date ? 'Current Day' : filters?.month ? 'Current Month' : 'Current Week';

  return (
    <Container fluid className='pt-4' style={{
      height:'100vh',
    }}>
      {/* Dashboard Header */}
      <div className="dashboard-header" style={{ borderBottom: 'none' }}>
        {/* Controls row */}
        <Row className="d-flex justify-content-between align-items-start ">
          <Col md="7">
            <div className="header-content">
  <h4 className="dashboard-title mb-2">Unilever Safety AI Dashboard</h4>
  <p className="dashboard-subtitle mb-2">Real Time Safety Monitoring System</p>
  <span className="week-info">{filters?.week ? formatWeek(filters.week) : filters?.month ? formatMonth(filters.month) : filters?.date || ''}</span>
  <p className="filters-content m-0 p-0 mt-1">{filters?.area && `${filters?.area}`} {filters?.subarea && `- ${filters?.subarea}`}</p>
</div>
          </Col>
          <Col className='d-flex justify-content-end' md="5">

            <div
  type="button"
  className={`d-flex justify-content-center align-items-center filter-btnn ${showFilters && "border_R"}`}
  ref={filterButton}
  onClick={() => setShowFilters(!showFilters)}
  style={{
    backgroundColor: "#fff",
    border: "2px solid #e0e0e0",
    minHeight: '60px'
  }}
>
  <p className="m-0 fw-bold" style={{ fontSize: "20px", color: "#000" }}>
    Filters
  </p>
  <RiMenu5Line color="#8c8c8c" size={24} className="ms-3" />
</div>






          </Col>

          {/* <Col md="4" className="text-end">
            <div className="header-right" style={{position:'relative'}}>
              <button className="filter-button" ref={filterButton} onClick={() => setShowFilters(!showFilters)} style={{display:'inline-flex', alignItems:'center'}}>
                <Filter size={16} />
                Filter
              </button>
              {showFilters && (
                <div className={`filter-card shadow-sm`} ref={filterCardRef} style={{position:'absolute', right:0, top:'100%', zIndex: 1050, minWidth: 240, borderRadius: 12, overflow: 'hidden'}}>
                  <div className="d-flex align-items-center justify-content-center" style={{background:'#1e66f5', color:'#fff', padding:'10px 16px'}}>
                    <span style={{fontWeight:600, fontSize:18}}>Filters</span>
                    <Filter size={18} style={{marginLeft:8}} />
                  </div>
                  <div className="d-flex flex-column gap-2" style={{padding:'14px'}}>
                    <CommonFIlterButton data={shifts.map(s=>s.label)} handleInputChange={handleInputChange} style={{ width: '100%', height: '38px', fontSize: 13, margin: '0' }} selectedItem={filters?.shift} firstOption={'Select Shift'} inputChangeOption={'shift'} clName={`${filters?.shift && ''} filter-button-size`} />
                    <Input className={`filter-button-size margin-for-weekly input-border-class-weekly m-0`} type="week" name="week" id="week" max={getCurrentWeekWithYear()} value={filters.weekly || ''} placeholder="Select Week" style={{ width: '100%', height: '38px', fontSize: 13, margin: '0' }} onChange={handleWeekChange} />
                    <Input className={`filter-button-size input-border-class-month m-0`} type="month" name="month" id="month" max={new Date().toISOString().slice(0, 7)} value={filters.month || ''} style={{ width: '100%', height: '38px', fontSize: 13, margin: '0' }} onChange={handleMonthChange} />
                  </div>
                </div>
              )}
            </div>
          </Col> */}
        </Row>
        <div className="w-100 d-flex justify-content-end position-relative">
          {showFilters && (
            <div
              style={{ position: 'absolute', top: filters?.area ? '-110px' : '-80px' }}
              className={`d-flex align-items-center justify-content-center gap-2 py-3 filter-card shadow-sm`}
              ref={filterCardRef}
            >
              <div className="d-flex align-items-center justify-content-center flex-wrap gap-2">
                <Input
                  className="rounded-3"
                  type="select"
                  name="dateType"
                  id="dateType"
                  style={style}
                  value={selectedOption}
                  onChange={handleDateDrop}
                >
                  {dateChoose.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
                </Input>
                <LiveAlertsFilters
                  maxWeek={getCurrentWeekWithYear()}
                  //  role={role}
                  areas={areas}
                  subarea={subareas[filters?.area]}
                  //  modulesforAlerts={modules}
                  //  ViolationSeverity={severities}
                  handleDateDrop={handleDateDrop}
                  //  currentWeekk={currentWeekk}
                  style={style}
                  handleNewInputChange={handleInputChange}
                  newFilters={filters}
                  selectedOption={selectedOption}
                  dateShow={dateShow}
                  monthShow={monthShow}
                  weeklyShow={weeklyShow}
                  //  customDate={customDate}
                  typeHeadFilter={false}
                />
                {/* Show Shift after sub area selection */}
                {(filters?.subarea || (filters?.area && subareas[filters?.area]?.length)) && (
                  <Input
                    className={`filter-button-size m-0`}
                    type="select"
                    name="shift"
                    id="shift"
                    value={filters.shift || ''}
                    style={{ ...style, minWidth: '145px' }}
                    onChange={(e) => handleInputChange(e, 'shift')}
                  >
                    <option value="">Select Shift</option>
                    {shifts.map((s, idx) => (
                      <option key={idx} value={s.label}>{s.label}</option>
                    ))}
                  </Input>
                )}


                {showButtons && (
                  <>
                    <div className="d-flex flex-wrap gap-2 justify-content-center">
                      <Button
                        style={style}
                        className={`m-0 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly`}
                        onClick={applyfilters}
                        color=""
                      >
                        <IoCheckmarkOutline
                          style={{
                            color: "#22c65e",
                            fontSize: "20px",
                            transform: "rotate(20deg)",
                          }}
                        />
                        <p
                          style={{ color: "#22c65e" }}
                          className="m-0 p-0 "
                        >
                          {" "}
                          Accept
                        </p>
                      </Button>
                      <Button
                        style={style}
                        className={`m-0 p-0 rounded-3 shadow-sm d-flex align-items-center justify-content-evenly`}
                        onClick={Reset}
                        color=""
                      >
                        <RxReset
                          style={{
                            color: "#4e74d4",
                            fontSize: "20px",
                            // transform: "rotate(20deg)",
                          }}
                        />
                        <p
                          style={{ color: "#4e74d4" }}
                          className="m-0 p-0 "
                        >
                          {" "}
                          Reset
                        </p>
                      </Button>

                      {/* <Button
                               style={style}
                               className="rounded-3"
                               onClick={Reset}
                               color="primary"
                             >
                               <RxReset />
                             </Button> */}
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {
        loading ? <div>
          <div className="d-flex align-items-center justify-content-center" style={{ height: '300px' }}>
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div> : <>
          <Row className="">
            <Col xs="12" xl="4" className="d-flex area-col">
              {/* Area Status Card */}
              <Card className="area-status-card w-100 h-100">
                <CardBody className="d-flex flex-column align-items-center justify-content-center text-center" style={{ gap: "12px" }}>
                  <h6 className="status-title" style={{ marginBottom: 0 }}>
                    Area Status
                  </h6>

                  <div aria-label="siren-icon" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                      {/* Base plate */}
                      <rect x="19" y="44" width="28" height="8" rx="2" fill={online ? "#00B400" : "#EF0000"} />
                      {/* Inner dark slit on the base */}
                      <rect x="21" y="40" width="24" height="4" rx="1.5" fill={online ? "#008000" : "#B40000"} />
                      {/* Dome */}
                      <path d="M22 40V30C22 23.373 27.373 18 34 18C40.627 18 46 23.373 46 30V40H22Z" fill={online ? "#4CFF4C" : "#FF4C4C"} />
                      {/* Highlight curve */}
                      <path d="M34 24C31.6 25 30 27.2 29.6 29.6" stroke={online ? "#7AFF7A" : "#FF7A7A"} strokeWidth="3" strokeLinecap="round" />
                      {/* Top small dot/ray */}
                      <rect x="31" y="10" width="2" height="6" rx="1" fill={online ? "#00FF00" : "#FF0000"} />
                      {/* Diagonal rays */}
                      <rect x="45" y="14" width="2" height="6" rx="1" transform="rotate(30 45 14)" fill={online ? "#00FF00" : "#FF0000"} />
                      <rect x="19" y="14" width="2" height="6" rx="1" transform="rotate(-30 19 14)" fill={online ? "#00FF00" : "#FF0000"} />
                      {/* Side short bars */}
                      <rect x="12" y="28" width="6" height="3" rx="1.5" fill={online ? "#00FF00" : "#FF0000"} />
                      <rect x="46" y="28" width="6" height="3" rx="1.5" fill={online ? "#00FF00" : "#FF0000"} />
                    </svg>
                  </div>

                  <span
                    className="status-text"
                    style={{
                      marginTop: "2px",
                      fontWeight: 700,
                      letterSpacing: "0.2px",
                      padding: "6px 18px",
                      borderRadius: 999,
                      background: online ? "#e3f6ec" : "#fbe4e4",
                      color: online ? "#1a8f5e" : "#c22f2f"
                    }}
                  >
                    {online ? "Online" : "Offline"}
                  </span>
                </CardBody>
              </Card>
            </Col>

            <Col xs="12" xl="4" className="d-flex metric-col">
              {/* Total Number of Alerts Card */}
              <Card className="total-alerts-card w-100 h-100">
                <CardBody>
                  <div className="alerts-header">
                    <h6 className="alerts-title">Total Number of Alerts</h6>
                    <div className="main-metric">
                      <AlertTriangle className="alert-icon" size={3} />
                      <span className="metric-number">{AllLiveAlerts[0]?.total_records}</span>
                      <TrendingUp className="trend-arrow" size={16} />
                    </div>
                  </div>
                  <div className="status-buttons">
                    {/* Pending - light blue */}
                    <div style={{ flex: 1, background: '#e4eefc', border: '1px solid #d4e1f6', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#0e2f8c', marginBottom: 8 }}>Pending</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#0e2f8c' }}>{AllLiveAlerts[0]?.total_records - (AllLiveAlerts[0]?.total_supervisor_accepted + AllLiveAlerts[0]?.total_supervisor_rejected)}</span>
                    </div>
                    {/* Acknowledge - light green */}
                    <div style={{ flex: 1, background: '#eaf7ef', border: '1px solid #d7efdf', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#1f7a55', marginBottom: 8 }}>Acknowledge</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#1f7a55' }}>{AllLiveAlerts[0]?.total_supervisor_accepted}</span>
                    </div>
                    {/* Not an Alert - light red */}
                    <div style={{ flex: 1, background: '#fdeeee', border: '1px solid #f5d9d9', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#c62828', marginBottom: 8 }}>Not an Alert</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#c62828' }}>{AllLiveAlerts[0]?.total_supervisor_rejected}</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xs="12" xl="4" className="d-flex metric-col">
              {/* Weekly Alert Analysis Card */}
              <Card className="total-alerts-card w-100 h-100">
                <CardBody>
                  <div className="alerts-header">
                    <h6 className="alerts-title">{periodTypeLabel} Alert Analysis</h6>
                    <div className="main-metric">
                      <AlertOctagon className="alert-icon" size={12} />
                      <span className="metric-number">{AllLiveAlerts[0]?.total_records || 0}</span>
                      <TrendingUp className="trend-arrow" size={16} />
                    </div>
                    <small style={{ fontSize: '16px', fontWeight: '700' }} className='text-center f-light mt-2'>
                      {AllLiveAlerts[0]?.week_label ? `${AllLiveAlerts[0].week_label} (${currentPeriodLabel})` : currentPeriodLabel}
                    </small>
                  </div>
                  <div className="status-buttons">
                    <div style={{ flex: 1, background: '#f6f8fb', border: '1px solid #e6e9ef', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#5b5b5b', marginBottom: 8 }}>{AllLiveAlerts[1]?.week_label || "Current week"}</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#5b5b5b' }}>{AllLiveAlerts[1]?.total_records || 0}</span>
                    </div>
                    <div style={{ flex: 1, background: '#f6f8fb', border: '1px solid #e6e9ef', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#5b5b5b', marginBottom: 8 }}>{AllLiveAlerts[2]?.week_label || "Current week"}</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#5b5b5b' }}>{AllLiveAlerts[2]?.total_records || 0}</span>
                    </div>
                    <div style={{ flex: 1, background: '#f6f8fb', border: '1px solid #e6e9ef', borderRadius: 14, padding: '18px 14px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                      <span style={{ fontWeight: 600, fontSize: 15, color: '#5b5b5b', marginBottom: 8 }}>{AllLiveAlerts[3]?.week_label || "Current week"}</span>
                      <span style={{ fontWeight: 700, fontSize: 28, color: '#5b5b5b' }}>{AllLiveAlerts[3]?.total_records || 0}</span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xs="12" xl="12" className=" mt-4  ">
            <Card>
              <CardHeader style={{fontSize:'25px', fontWeight:'700'}}>Supervisors</CardHeader>
            <CardBody className='p-4'>
  <div className='row g-4'>
    {supervisors?.map((supervisor, index) => {
      const initials = (supervisor?.name || 'NA')
        .trim()
        .split(/\s+/)
        .map((w) => w[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
      const resolutionRate = Math.round(
        ((supervisor?.acknowledged || 0) / (supervisor?.totalAlerts || 1)) * 100
      );
      const isActive = !!supervisor?.shift_status;

      return (
      <div key={index} className='col-xl-3 col-lg-4 col-md-6 col-sm-12'>
        <div
          className='sup-card h-100 d-flex flex-column'
          style={{
            background: isActive ? 'linear-gradient(180deg, #fff6f6 0%, #ffffff 65%)' : '#ffffff',
            borderColor: isActive ? '#f6d4d4' : '#eef1f5',
          }}
        >
          {/* Header */}
          <div className='d-flex align-items-start justify-content-between mb-3'>
            <div className='d-flex align-items-center gap-3'>
              <div
                className='sup-avatar'
                style={{
                  background: isActive ? '#fbe4e4' : '#e8eefc',
                  color: isActive ? '#c22f2f' : '#2c4fc4',
                }}
              >
                {initials}
              </div>
              <div>
                <h5 className='sup-name mb-0'>{supervisor?.name || 'Unnamed Supervisor'}</h5>
                <span className='sup-role'>Supervisor</span>
              </div>
            </div>
            <span className={`sup-status-chip ${isActive ? 'is-active' : 'is-inactive'}`}>
              <span className='sup-status-dot' />
              {isActive ? 'Active' : 'Inactive'}
            </span>
          </div>

          {/* Area / Sub-area meta */}
          {(supervisor?.area?.length > 0 || supervisor?.sub_area?.length > 0) && (
            <div className='sup-meta mb-3'>
              {supervisor?.area?.length > 0 && (
                <div className='sup-meta-row'>
                  <MapPin size={16} className='sup-meta-icon' />
                  <span>{supervisor.area.join(', ')}</span>
                </div>
              )}
              {supervisor?.sub_area?.length > 0 && (
                <div className='sup-meta-row'>
                  <span className='sup-meta-icon-spacer' />
                  <span className='sup-meta-sub'>{supervisor.sub_area.join(', ')}</span>
                </div>
              )}
            </div>
          )}

          <div className='sup-divider' />

          {/* Stats */}
          <div className='sup-stats'>
            <div className='sup-stat'>
              <span className='sup-stat-value'>{supervisor?.totalAlerts || 0}</span>
              <span className='sup-stat-label'>Total</span>
            </div>
            <div className='sup-stat'>
              <span className='sup-stat-value sup-stat-emerald'>{supervisor?.acknowledged || 0}</span>
              <span className='sup-stat-label'>Ack.</span>
            </div>
            <div className='sup-stat'>
              <span className='sup-stat-value sup-stat-amber'>{supervisor?.falseAlert || 0}</span>
              <span className='sup-stat-label'>False</span>
            </div>
            <div className='sup-stat'>
              <span className='sup-stat-value sup-stat-rose'>{supervisor?.pendingAlert || 0}</span>
              <span className='sup-stat-label'>Pending</span>
            </div>
          </div>

          <div className='sup-divider' />

          {/* Resolution Rate */}
          <div className='mb-1'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
              <span className='sup-progress-label'>Resolution Rate</span>
              <span className='sup-progress-value'>{resolutionRate}%</span>
            </div>
            <div className='sup-progress-track'>
              <div className='sup-progress-fill' style={{ width: `${resolutionRate}%` }} />
            </div>
          </div>

          {/* Action */}
          <div className='mt-auto pt-3'>
            <button
              type='button'
              className={`sup-action-btn ${isActive ? 'is-danger' : 'is-success'}`}
              onClick={() => openStatusModal(supervisor)}
            >
              <Power size={17} />
              {isActive ? 'Deactivate Shift' : 'Activate Shift'}
            </button>
          </div>
        </div>
      </div>
      );
    })}
  </div>
</CardBody>

<style jsx>{`
  .sup-card {
    border: 1px solid #eef1f5;
    border-radius: 18px;
    padding: 26px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 6px 16px rgba(15, 23, 42, 0.05);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
  }

  .sup-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(15, 23, 42, 0.06), 0 12px 24px rgba(15, 23, 42, 0.08);
  }

  .sup-avatar {
    width: 54px;
    height: 54px;
    min-width: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.3px;
  }

  .sup-name {
    font-size: 21px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
  }

  .sup-role {
    font-size: 13px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }

  .sup-status-chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 6px 13px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
    margin-top: 2px;
  }

  .sup-status-chip.is-active {
    background: #fbe4e4;
    color: #c22f2f;
  }

  .sup-status-chip.is-inactive {
    background: #e3f6ec;
    color: #1a8f5e;
  }

  .sup-status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: currentColor;
  }

  .sup-meta-row {
    display: flex;
    align-items: flex-start;
    gap: 7px;
    font-size: 15px;
    color: #64748b;
    line-height: 1.5;
    margin-bottom: 3px;
  }

  .sup-meta-icon {
    color: #a0aec0;
    margin-top: 3px;
    flex-shrink: 0;
  }

  .sup-meta-icon-spacer {
    width: 16px;
    flex-shrink: 0;
  }

  .sup-meta-sub {
    color: #94a3b8;
  }

  .sup-divider {
    height: 1px;
    background: #eef1f5;
    margin: 16px 0;
  }

  .sup-stats {
    display: flex;
    align-items: stretch;
  }

  .sup-stat {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 0 4px;
  }

  .sup-stat:not(:last-child) {
    border-right: 1px solid #eef1f5;
  }

  .sup-stat-value {
    font-size: 26px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.2;
  }

  .sup-stat-emerald {
    color: #0f9d68;
  }

  .sup-stat-amber {
    color: #c9860a;
  }

  .sup-stat-rose {
    color: #d63a3a;
  }

  .sup-stat-label {
    font-size: 13px;
    font-weight: 600;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .sup-progress-label {
    font-size: 14px;
    font-weight: 600;
    color: #94a3b8;
  }

  .sup-progress-value {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
  }

  .sup-progress-track {
    height: 8px;
    border-radius: 999px;
    background: #eef1f5;
    overflow: hidden;
  }

  .sup-progress-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, #34c98a, #16a06a);
    transition: width 0.3s ease;
  }

  .sup-action-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    border: none;
    border-radius: 12px;
    padding: 13px 16px;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    transition: filter 0.2s ease, transform 0.15s ease;
  }

  .sup-action-btn:active {
    transform: scale(0.98);
  }

  .sup-action-btn.is-success {
    background: #e3f6ec;
    color: #1a8f5e;
  }

  .sup-action-btn.is-success:hover {
    filter: brightness(0.97);
  }

  .sup-action-btn.is-danger {
    background: #fbe4e4;
    color: #c22f2f;
  }

  .sup-action-btn.is-danger:hover {
    filter: brightness(0.97);
  }
`}</style>
            </Card>
            </Col>
          </Row>


          <Row className="mt-3 mx-0 px-0 w-100">
            <Col className='w-100 mx-0 px-0' xs="12">
              <HeatmapForArea
                heatmapData={heatmapLiveData}
                // moduleLength={heatmapData?.data?.length || 0}
                loader={loading}
                filters={effectiveFilters || uiFilters}
                AreaDashboard={true}
                NoEvent={true}
                rykAdmin={true}
                showSupervisor={true}
              />

            </Col>
          </Row>

        </>
      }

      <Modal isOpen={statusModalOpen} toggle={closeStatusModal} centered>
        <ModalHeader toggle={closeStatusModal}>
          Confirm Shift Status Change
        </ModalHeader>
        <ModalBody className='text-center py-4'>
          <p className='mb-0 fs-6'>
            Are you sure you want to {selectedSupervisor?.shift_status ? 'deactivate' : 'activate'} shift status
            {selectedSupervisor?.name ? ` for ${selectedSupervisor.name}` : ''}?
          </p>
        </ModalBody>
        <ModalFooter className='justify-content-center gap-2'>
          <Button
            color={selectedSupervisor?.shift_status ? 'danger' : 'success'}
            onClick={handleConfirmStatusChange}
            disabled={statusUpdating}
            className='px-4'
          >
            {statusUpdating ? <Spinner size='sm' color='light' /> : 'Yes'}
          </Button>
          <Button
            color='secondary'
            outline
            onClick={closeStatusModal}
            disabled={statusUpdating}
            className='px-4'
          >
            No
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default LiveAnalyticsNewDesgin;